<div
    #multipleSelectionContainer
    cdkOverlayOrigin
    #trigger="cdkOverlayOrigin"
    class="container"
    tabindex="0"
    (click)="openPanel($event)"
    (mousedown)="$event.stopPropagation()"
    (keydown)="onKeyDown($event)"
>
    <lib-search-input
        #searchInput
        class="select"
        [(text)]="searchText"
        [searchIcon]="false"
        [removeBorder]="true"
        [placeholderText]="'Search...'"
        [clearValueButton]="true"
        [useTimeout]="false"
        (textChange)="onSearchChanged($event)"
        (keydown)="onKeyDown($event)"
    >
    </lib-search-input>

    <ng-template
        cdkConnectedOverlay
        [cdkConnectedOverlayOrigin]="trigger"
        [cdkConnectedOverlayOpen]="isOpen()"
        [cdkConnectedOverlayScrollStrategy]="scrollStrategy"
        [cdkConnectedOverlayWidth]="overlayWidth()"
        [cdkConnectedOverlayPush]="true"
        [cdkConnectedOverlayBackdropClass]="'cdk-overlay-custom-backdrop'"
        (overlayOutsideClick)="closePanel()"
        (detach)="closePanel()"
        (backdropClick)="closePanel()"
    >
        <div
            class="panel"
            tabindex="0"
            (click)="$event.stopPropagation()"
            (mousedown)="$event.stopPropagation()"
            (keydown)="onKeyDown($event)"
        >
            <div class="options">
                @if (loading()) {
                    <app-loading-spinner [ngClass]="{ fadeIn: true, fadeOut: false }"></app-loading-spinner>
                } @else {
                    @for (item of filteredItems(); track item[config().identityKey]) {
                        <label class="option" [class.inactive]="!item['isActive']">
                            <input type="checkbox" [checked]="isTempSelected(item)" (change)="toggleItem(item)" />
                            <div class="userInfo">
                                <span class="name">{{ item[config().labelKey] }}</span>
                                @if (config().secondaryLabel) {
                                    <span class="secondary">{{ item[config().secondaryLabel ?? ''] }}</span>
                                }
                            </div>
                        </label>
                    }

                    @if (!filteredItems().length) {
                        <div class="empty">No results</div>
                    }
                }
            </div>

            <div class="actions">
                <button
                    type="button"
                    class="clear"
                    (mousedown)="$event.stopPropagation()"
                    [disabled]="clearDisabled()"
                    (click)="clearVisible()"
                >
                    Clear Selections
                </button>

                <button
                    type="button"
                    class="apply"
                    (mousedown)="$event.stopPropagation()"
                    [disabled]="applyDisabled()"
                    (click)="apply()"
                >
                    Apply
                </button>
            </div>
        </div>
    </ng-template>
</div>
